<template>
    <div class="create-modal">
        <el-dialog  :visible.sync="dialogCreate"
                    title="创建模式"
                    :show-close="false"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false">
           <div class="create-modal__form">
               <el-form :model="modal" autoComplete="on" :rules="createModalFormRules" ref="createModalForm">
                   <el-form-item label="模式名称：" :label-width="formLabelWidth" prop="name">
                       <el-input v-model="modal.name" autocomplete="off" clearable @keyup.enter.native="submitDetail" ></el-input>
                   </el-form-item>
                   <el-form-item label="首页地址：" :label-width="formLabelWidth" prop="address">
                       <el-input v-model="modal.address" autocomplete="off" clearable @keyup.enter.native="submitDetail" ></el-input>
                   </el-form-item>
                   <el-form-item label="模式描述：" :label-width="formLabelWidth" prop="description">
                       <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 5}" clearable placeholder="请输入内容"
                                 v-model="modal.description" @keyup.enter.native="submitDetail"></el-input>
                   </el-form-item>
                   <el-form-item label="logo图片：" :label-width="formLabelWidth" prop="logo" style="text-align:left">
                       <el-upload class="create-modal__avatar" :action="this.uploadURL"  :show-file-list="false" list-type="picture"
                               :on-success="handleAvatarSuccess"
                               :before-upload="beforeAvatarUpload">
                           <img v-if="modal.logo" :src="this.imgUrl +modal.logo" class="create-modal__image">
                           <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       </el-upload>
                   </el-form-item>
               </el-form>
           </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="success" @click="previewEvent">预览</el-button>
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click.native.prevent="submitDetail">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="iframeDialog"
                 width="80%"
                 center>
            <iframe width="100%" height="600px" :src="iframeSrc" frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>

<script>
    export default({
          data(){
             return{
                 iframeDialog:false,
                 iframeSrc:'',
                 modal: {
                     name:'',
                     address:'' ,
                     description:'',
                     logo:'',
                     status:2
                 },
                 formLabelWidth: '110px',
                 createModalFormRules:{
                     name: [{ required: true, trigger: "blur", message: "请输入模式名称"  }],
                     address: [{ required: true, message: "请输入首页地址"  }],
                     description: [{ required: true, message: "请输入描述信息"  }],
                     logo: [{ required: true, message: "请上传logo图片"  }],

                 },
             }
          },
        props:{
            dialogCreate:{
                type:Boolean,
                default:false
            },
            type:{
                type:Number,
                default:false,
            }
        },
        methods:{
            handleAvatarSuccess(res, file) {
                this.modal.logo = res.data.store_result
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 10MB!');
                }
                return isLt2M;
            },
            closeDialog(){
                this.$emit('closeCreateModal',false);
                this.$refs['createModalForm'].resetFields();
            },
            submitDetail(){
                this.$refs["createModalForm"].validate(valid => {
                    if(valid){
                        this.modal.type = this.type
                        this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/mode/create`,this.modal).then(res=>{
                            if(res.code == 0){
                                this.closeDialog()
                                this.$message.success('保存成功')
                                this.$emit('updateEditModulesList')
                            }
                        })
                    }
                })
            },
            previewEvent(){
               if(this.modal.address){
                   this.iframeSrc = this.modal.address
                   this.iframeDialog = true
               }else{
                   this.$message.error('请填写首页地址')
               }
            }
        }
    })
</script>

<style lang="scss" scoped>
    @include component(create-modal){
        @include part(title){
            font-size: 1rem;
            color: #000;
            text-align: center;
            margin-top: -1rem;
            margin-bottom: 3rem;

        }
        /*上传图片*/
		.is_border {
			border: 1px dashed #ddd !important;
			border-radius: 5px;
			height: 178px !important;
			line-height: 178px !important;
		}

		.upload_btn {
			display: block;
			background-color: #00a1ff;
			font-weight: bold;
			color: #fff;
			padding: 2px;
			border-bottom-left-radius: 3px;
			border-bottom-right-radius: 3px;
		}

		.upload_btn:hover {
			background-color: #13ce66;
		}

		.del_img {
			position: absolute;
			top: -7px;
			left: 224px;
			color: #00a1ff;
		}

		.del_img:hover {
			cursor: pointer;
			color: #f00;
		}

		.del_img i:before {
			font-size: 20px;
		}

		.img_border {
			border-top-left-radius: 3px;
			border-top-right-radius: 3px;
			width: 178px;
            height: 178px;
			display: block;
		}

		.avatar-uploader {
			text-align: center;
			width: 178px;
            height: 178px;
		}

		/deep/ .el-upload {
			border: 1px dashed #d9d9d9 !important;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		/deep/ .el-upload:hover {
			border-color: #409eff !important;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 178px;
            height: 178px;
			line-height: 178px;
			text-align: center;
		}

        .create-modal__image{
            width: 178px;
            height: 178px;
            display: block;
        }
    }
</style>